import React from "react";
import { Box } from "@mui/material";

type Props = {
  url: string;
};

const getEmbedUrl = (url: string) => {
  if (!url) return "";
  let videoId = "";
  if (url.includes("youtu.be/")) {
    videoId = url.split("youtu.be/")[1].split("?")[0];
  } else if (url.includes("youtube.com/watch?v=")) {
    videoId = url.split("v=")[1].split("&")[0];
  } else if (url.includes("youtube.com/embed/")) {
    return url;
  }

  return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
};

const MapMarkerRainforestVideoEmbed = ({ url }: Props) => {
  if (!url) return null;

  const baseEmbedUrl = getEmbedUrl(url);
  // Append controls=1 to show YouTube controls
  const embedUrl = baseEmbedUrl.includes("?")
    ? `${baseEmbedUrl}&controls=1`
    : `${baseEmbedUrl}?controls=1`;

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        paddingTop: "56.25%", // 16:9 Aspect Ratio
        borderRadius: 2,
        overflow: "hidden",
        mb: 2,
        bgcolor: "black",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      <iframe
        src={embedUrl}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          border: 0,
        }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Rainforest Project Video"
      />
    </Box>
  );
};

export default MapMarkerRainforestVideoEmbed;
